import { useDroppable } from "@dnd-kit/core";
import { ReactNode } from "react";

export type DroppableItemProps = {
  id: string;
  children: (props: { isOver: boolean }) => ReactNode;
  disabled?: boolean;
  className?: string;
};

export const DroppableItem = ({
  id,
  children,
  className,
  disabled,
}: DroppableItemProps) => {
  const { setNodeRef, isOver } = useDroppable({ id, disabled });

  return (
    <div ref={setNodeRef} className={className}>
      {children({
        isOver,
      })}
    </div>
  );
};
